// extracted by mini-css-extract-plugin
module.exports = {"currencyInput":"CurrencyInput_currencyInput__1cN9L","mid":"CurrencyInput_mid__3mDf1"};